import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { ScoringFragmentDoc } from '../../../../pages/graphql/fragments/Scoring.fragment';
import { WatchNowOfferFragmentDoc } from '../../../../pages/graphql/fragments/WatchNowOffer.fragment';
export type WatchlistTitleGraphqlFragment = {
	__typename?: 'TitleListEdgeV2';
	cursor: string;
	node:
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				offers?: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					retailPrice?: string | null;
					type: Types.OfferType;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					elementCount?: number | null;
					deeplinkRoku?: string | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
					};
				}>;
				content: {
					__typename?: 'MovieContent';
					title: string;
					fullPath: string;
					originalReleaseYear?: number | null;
					shortDescription?: string | null;
					posterUrl?: string | null;
					isReleased: boolean;
					genres: Array<{ __typename?: 'Genre'; shortName: string }>;
					scoring: {
						__typename: 'Scoring';
						imdbScore?: number | null;
						imdbVotes?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
						jwRating?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
						hideJWRating: boolean;
					};
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
				};
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				offers?: Array<{
					__typename?: 'Offer';
					id: string;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					retailPrice?: string | null;
					type: Types.OfferType;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					elementCount?: number | null;
					deeplinkRoku?: string | null;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						clearName: string;
						shortName: string;
					};
				}>;
				content: {
					__typename?: 'ShowContent';
					title: string;
					fullPath: string;
					originalReleaseYear?: number | null;
					shortDescription?: string | null;
					posterUrl?: string | null;
					isReleased: boolean;
					genres: Array<{ __typename?: 'Genre'; shortName: string }>;
					scoring: {
						__typename: 'Scoring';
						imdbScore?: number | null;
						imdbVotes?: number | null;
						tmdbPopularity?: number | null;
						tmdbScore?: number | null;
						jwRating?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
						hideJWRating: boolean;
					};
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
				};
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					mediaDealId?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  };
};

export const WatchlistTitleGraphqlFragmentDoc = gql`
	fragment WatchlistTitleGraphql on TitleListEdgeV2 {
		cursor
		node {
			__typename
			id
			objectId
			objectType
			offerCount(country: $country, platform: $platform)
			offers(country: $country, platform: $platform, filter: { preAffiliate: true })
				@include(if: $includeOffers) {
				id
				presentationType
				monetizationType
				retailPrice(language: $language)
				type
				package {
					id
					packageId
					clearName
					shortName
				}
				standardWebURL
				preAffiliatedStandardWebURL
				elementCount
				deeplinkRoku: deeplinkURL(platform: ROKU_OS)
			}
			content(country: $country, language: $language) {
				title
				fullPath
				originalReleaseYear
				shortDescription
				genres {
					shortName
				}
				scoring {
					...Scoring
				}
				posterUrl(profile: $profile, format: $format)
				backdrops(profile: $backdropProfile, format: $format) {
					backdropUrl
				}
				upcomingReleases(releaseTypes: [DIGITAL]) {
					releaseDate
				}
				isReleased
			}
			likelistEntry {
				createdAt
			}
			dislikelistEntry {
				createdAt
			}
			watchlistEntryV2 {
				createdAt
			}
			customlistEntries {
				createdAt
			}
			watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
				...WatchNowOffer
			}
			... on Movie {
				seenlistEntry {
					createdAt
				}
			}
			... on Show {
				tvShowTrackingEntry {
					createdAt
				}
				seenState(country: $country) {
					seenEpisodeCount
					releasedEpisodeCount
					progress
					caughtUp
					lastSeenEpisodeNumber
					lastSeenSeasonNumber
				}
			}
		}
	}
	${ScoringFragmentDoc}
	${WatchNowOfferFragmentDoc}
`;
